import type {Content} from '@prismicio/client'
import type {SliceComponentProps} from '@prismicio/react'
import type {FC} from 'react'
import {BentoGridDefaultVariation} from './variations/DefaultVariation'
import {BentoGridIconCardsVariation} from './variations/IconCardsVariation'

/**
 * Props for `BentoGrid`.
 */
export type BentoGridProps = SliceComponentProps<Content.BentoGridSlice>

/**
 * Component for "BentoGrid" Slices.
 */
const BentoGrid: FC<BentoGridProps> = ({slice}) => {
  switch (slice.variation) {
    case 'iconCards':
      return <BentoGridIconCardsVariation slice={slice} />
    case 'default':
      return <BentoGridDefaultVariation slice={slice} />
    default:
      return null
  }
}

export default BentoGrid
